import React from "react";
import classNames from "classnames";
import { cdn } from "utilities/cdnUtils";

interface Props {
  connectUrl: string
  canDisconnect: boolean
  userDetails: server.dto.GoogleIdentityUserDetails
  settingsUrl?: string
}

const DisconnectButton = () => {
  const [isDisconnecting, setIsDisconnecting] = React.useState<boolean>(false);
  const onDisconnect = (e: React.MouseEvent) => {
    e.preventDefault();

    if (isDisconnecting) {
      return;
    }
    setIsDisconnecting(true);

    window.CoreApi.ExternalIdentity.Disconnect({ provider: "google" })
      .then(() => {
        window.location.reload();
      });
  };

  return <button
    onClick={onDisconnect}
    className="button-new warning">{RESX.ConnectedAccount.Disconnect}
  </button>;
};

const NotConnected = ({ connectUrl }: { connectUrl: string }) => {
  const Connect = (e: React.MouseEvent) => {
    e.preventDefault();

    window.location.href = `${connectUrl}&returnurl=${encodeURIComponent(window.location.pathname)}`;
  };

  return <button
    onClick={Connect}
    className="s1_button google fluid" style={{ height: 55 }}>
    <div className="flex align-center padding-small justify-center">
      <h4>{RESX.PersonalSettings.ConnectToGoogle}</h4>
    </div>
  </button>;
};

const Google = (props: Props) => {
  if (props.userDetails == null) {
    return <NotConnected connectUrl={props.connectUrl} />;
  }

  const onClick = () => {
    if (props.settingsUrl) {
      document.location.href = props.settingsUrl;
    }
  };

  const cssClasses = (): string => classNames({
    "flex card-floating-bg radius padding-large": true,
    hoverable: (props.settingsUrl)
  });

  return <div className={cssClasses()} onClick={onClick}>
    <div className="margin-right">
      <img src={cdn.static("/images/google_icon.png")} />
    </div>
    <div className="grow1">
      <div className="margin-bottom-mini"><h3>{props.userDetails.name.fullName}</h3></div>
      <div className="s1_gray" >{props.userDetails.email}</div>
    </div>
    {props.userDetails.calendarScope &&
      <div>
        <i className="icon-external s1_gray" title="SystemOne has access to retrieve Google calendars" />
      </div>}
    {props.canDisconnect && <div className="margin-left">
      <DisconnectButton />
    </div>}
  </div>;
};

export default Google;